export default __webpack_public_path__ + "locales/el-GR/ChangePortalOwner.json?hash=692fcaa6dc561bd1ee1125e7e513803b";